const blockedProtocols = new Set([
  'javascript:',
  'vbscript:',
  'data:',
  'file:',
  'blob:',
  'about:',
])

export function noteLinkHref(value: string): string | undefined {
  if (
    Array.from(value).some(
      (char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127,
    )
  )
    return undefined
  const trimmed = value.trim()
  const bareDomain =
    /^(?:localhost|(?:[\p{L}\p{N}-]+\.)+[\p{L}\p{N}-]+)(?::\d+)?(?:[/?#]|$)/u.test(
      trimmed,
    )
  const href = bareDomain ? `https://${trimmed}` : trimmed
  try {
    const url = new URL(href)
    if (
      blockedProtocols.has(url.protocol) ||
      url.username ||
      url.password ||
      !(url.hostname || url.pathname)
    )
      return undefined
    return href
  } catch {
    return undefined
  }
}
